import { isTeamsEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';

import { USAGE_UNLIMITED } from '../constants';
import { isModernSubscription } from '../subscriptions/isModernSubscription';
import type { LegacySubscription, ModernSubscription } from '../types';
import { LimitNames } from '../types';

/**
 * Returns the modern subscription limits regardless of the subscription type.
 * For legacy subscriptions, it returns the monthly active users and seats limits.
 */
export function getSubscriptionLimits(
  subscription?: ModernSubscription | LegacySubscription,
): ModernSubscription['_limits'] {
  if (!subscription) {
    return {};
  }

  if (isModernSubscription(subscription)) {
    return subscription._limits;
  }

  const seatLimit = isTeamsEnabled() ? subscription.seatCount || USAGE_UNLIMITED : 1;

  return {
    [LimitNames.MONTHLY_ACTIVE_USERS]: subscription._limits?.mauLimit ?? 0,
    [LimitNames.SEATS]: seatLimit,
  };
}
